/**
 * Country catalog used for filtering Movies & Series by origin.
 * Easily extensible — add new entries here and they appear automatically
 * as filter chips on /movies and /series.
 */
export type CountryEntry = {
  code: string;       // ISO-3166 alpha-2
  ar: string;
  en: string;
  fr: string;
  flag: string;
};

export const COUNTRIES: CountryEntry[] = [
  { code: "US", ar: "أمريكي",   en: "American", fr: "Américain", flag: "🇺🇸" },
  { code: "TR", ar: "تركي",     en: "Turkish",  fr: "Turc",      flag: "🇹🇷" },
  { code: "MA", ar: "عربي",     en: "Arabic",   fr: "Arabe",     flag: "🇲🇦" },
  { code: "FR", ar: "فرنسي",    en: "French",   fr: "Français",  flag: "🇫🇷" },
  { code: "GB", ar: "بريطاني",  en: "British",  fr: "Britannique", flag: "🇬🇧" },
  { code: "KR", ar: "كوري",     en: "Korean",   fr: "Coréen",    flag: "🇰🇷" },
  { code: "JP", ar: "ياباني",   en: "Japanese", fr: "Japonais",  flag: "🇯🇵" },
  { code: "IN", ar: "هندي",     en: "Indian",   fr: "Indien",    flag: "🇮🇳" },
  { code: "DE", ar: "ألماني",   en: "German",   fr: "Allemand",  flag: "🇩🇪" },
  { code: "ES", ar: "إسباني",   en: "Spanish",  fr: "Espagnol",  flag: "🇪🇸" },
];

// Group "Arab" countries under EG for the filter (extensible)
const ARAB_CODES = new Set(["EG", "SA", "AE", "MA", "DZ", "TN", "JO", "LB", "SY", "IQ", "KW", "QA", "OM", "BH", "YE", "LY", "SD", "PS"]);

export function matchesCountry(itemCountry: string | undefined, filterCode: string): boolean {
  if (!itemCountry) return false;
  if (filterCode === "EG") return ARAB_CODES.has(itemCountry.toUpperCase());
  return itemCountry.toUpperCase() === filterCode.toUpperCase();
}

export function getCountryByCode(code: string): CountryEntry | undefined {
  return COUNTRIES.find((c) => c.code.toUpperCase() === code.toUpperCase());
}
